import { render, staticRenderFns } from "./dadosIntegracao.vue?vue&type=template&id=0097d65d&"
import script from "./dadosIntegracao.vue?vue&type=script&lang=js&"
export * from "./dadosIntegracao.vue?vue&type=script&lang=js&"
import style0 from "./dadosIntegracao.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports